import { STANDE } from "../../standeTokens";

/** A marker colour per room, from the brand at full strength, so "Room 2"
 *  is the same blue in the planner, the strip and on a student's screen. */
const ROOM_MARKS = [
  STANDE.primaryBlue,
  STANDE.darkGreen,
  STANDE.darkYellow,
  STANDE.darkRed,
  STANDE.secondaryOrange,
  STANDE.black,
];

export const roomMark = (index) => ROOM_MARKS[index % ROOM_MARKS.length];

export const defaultRoomName = (index) => `Room ${index + 1}`;

/** Fisher–Yates, so a shuffle is a fair one. */
const shuffled = (list) => {
  const out = [...list];
  for (let i = out.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [out[i], out[j]] = [out[j], out[i]];
  }
  return out;
};

/**
 * Deal people into `count` rooms as evenly as they go — round the table,
 * so sizes never differ by more than one.
 */
export const splitIntoRooms = (people, count, { shuffle = false, names = [] } = {}) => {
  const n = Math.max(1, count);
  const rooms = Array.from({ length: n }, (_, i) => ({
    id: null,
    name: names[i] || defaultRoomName(i),
    members: [],
  }));
  (shuffle ? shuffled(people) : people).forEach((person, i) => {
    rooms[i % n].members.push(person);
  });
  return rooms;
};

/** Move one person to another room (or out of every room with `null`). */
export const movePerson = (rooms, personGuid, toIndex) => {
  let person = null;
  const without = rooms.map((room) => {
    const found = room.members.find((m) => m.guid === personGuid);
    if (found) person = found;
    return { ...room, members: room.members.filter((m) => m.guid !== personGuid) };
  });
  if (!person || toIndex == null) return without;
  return without.map((room, i) => (i === toIndex ? { ...room, members: [...room.members, person] } : room));
};

export const firstName = (name) => (name || "").split(" ")[0] || name;
